import type { SearchArea } from '@/lib/areaSearch';

/**
 * `SearchArea` → kontrakt `p_areas` funkcji `flat.offers_price_histogram`.
 *
 * KONTRAKT DEFINIUJE SQL, nie ten plik (migracja `20260927143752`). To jest świadomy kierunek:
 * gdyby kształt dyktował typ z TypeScriptu, dodanie czwartego rodzaju obszaru na froncie
 * cicho rozjechałoby histogram z listą — SQL przyjąłby nieznany obiekt i policzył co innego.
 * Po stronie bazy nieznany `kind` PRZERYWA WYJĄTKIEM, a po tej stronie przerywa ta funkcja;
 * test obok sprawdza obie strony na tym samym zestawie rodzajów.
 *
 * Nazwy pól są z SQL-a, nie z frontu: `radius_m`, `lon`, `south/west/north/east`.
 */
export type ObszarKontraktu =
  | { kind: 'city'; name: string }
  | { kind: 'district'; name: string }
  | { kind: 'subdistrict'; name: string }
  | { kind: 'station'; lat: number; lon: number; radius_m: number }
  | { kind: 'geo'; south: number; west: number; north: number; east: number };

export function obszarDoKontraktu(a: SearchArea): ObszarKontraktu {
  switch (a.kind) {
    case 'city':
    case 'district':
    case 'subdistrict':
      return { kind: a.kind, name: a.name };
    // A „Blisko do…” place is the same ±radius square as a metro chip (plan E4.2), so the
    // histogram counts it through the contract's existing `station` shape — no SQL change.
    case 'station':
    case 'place':
      return { kind: 'station', lat: a.lat, lon: a.lon, radius_m: a.radiusM };
    case 'geo':
      return { kind: 'geo', south: a.south, west: a.west, north: a.north, east: a.east };
    default: {
      // Nieosiągalne przy pełnym typie — i to jest cel: gdy dojdzie nowy rodzaj obszaru,
      // TypeScript pokaże ten wiersz jako błąd, zanim ktokolwiek zobaczy złe słupki.
      const nieznany: never = a;
      throw new Error(`Nieznany rodzaj obszaru w kontrakcie histogramu: ${JSON.stringify(nieznany)}`);
    }
  }
}

export function obszaryDoKontraktu(areas?: SearchArea[] | null): ObszarKontraktu[] | null {
  if (!areas?.length) return null;
  return areas.map(obszarDoKontraktu);
}
